import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Identifica',
  desc: 'Realizas el test de autodiagnóstico para conocer el estado de tu abdomen.'
}, {
  num: '02',
  title: 'Respira',
  desc: 'Dominas la técnica de apertura costal que activa tu faja natural.'
}, {
  num: '03',
  title: 'Aplica',
  desc: 'Sigues el calendario de 21 días para automatizar tu fuerza interna.'
}];
export function HowItWorksSection() {
  return <section className="py-12 md:py-24 bg-cream" data-id="element-74">
      <div className="max-w-5xl mx-auto px-5 lg:px-8" data-id="element-75">
        <div className="text-center mb-8 md:mb-16" data-id="element-76">
          <h2 className="text-2xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-77">
            Cómo funciona
          </h2>
          <div className="w-24 h-px bg-rosegold mx-auto" data-id="element-78"></div>
        </div>

        <div className="grid grid-cols-3 gap-4 md:gap-12" data-id="element-79">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="relative text-center" data-id="element-80">
              {/* Connector line for desktop */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-12 left-1/2 w-full h-px bg-rosegold/30" data-id="element-81"></div>}

              <div className="relative z-10 w-14 h-14 md:w-24 md:h-24 mx-auto bg-white rounded-full border border-rosegold flex items-center justify-center mb-3 md:mb-6 shadow-sm" data-id="element-82">
                <span className="text-base md:text-2xl font-serif text-rosegold" data-id="element-83">
                  {step.num}
                </span>
              </div>
              <h3 className="text-lg md:text-2xl font-serif text-charcoal mb-2 md:mb-4" data-id="element-84">
                {step.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed text-xs md:text-base" data-id="element-85">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}